import classNames from 'classnames';
import type { JSX, PropsWithChildren } from 'react';
import { Avatar } from '../avatar/avatar';
import { Header3, Paragraph } from '../typography/typography';

type ApplicationHeaderProps = {
  onNavigationProfileClick: () => void;
  user: {
    email: string;
    image: string | null;
    displayName: string;
  } | null;
  className?: string;
};

export const ApplicationHeader = ({ user, onNavigationProfileClick, children, className }: PropsWithChildren<ApplicationHeaderProps>) => (
  <div id="application-header" className={classNames('tds-shell-portal-opaque-spacer md:tds-shell-portal-opaque-spacer-medium', className)}>
    <header className="flex flex-row items-center tds-header md:tds-header-medium pl-200 md:pl-300 gap-200">
      {children}
      <button className="self-stretch overflow-hidden aspect-square tds-navigation-profile p-100 md:p-200 shrink-0 w-600 box-content" onClick={onNavigationProfileClick}>
        <Avatar user={user} />
      </button>
    </header>
  </div>
);

type HeaderProps = {
  id?: string;
  title?: string;
  text?: string | JSX.Element;
  className?: string;
  slotLeft?: JSX.Element;
  slotRight?: JSX.Element;
};

export const Header = ({ id, title, className, slotRight, slotLeft, text }: HeaderProps) => (
  <header className={className}>
    <div className="flex flex-row items-center gap-50">
      {slotLeft}
      <Header3
        as="div"
        id={id}
        className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-tds-color-copy-on-light-10"
      >
        {title}
      </Header3>
      {slotRight}
    </div>
    <Paragraph className="tds-modal-header-text" id={id}>{text}</Paragraph>
  </header>
);
